import {
  Component,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  AfterViewInit,
  ChangeDetectionStrategy,
  OnInit,
  Sanitizer,
  ChangeDetectorRef,
  OnDestroy,
  Renderer2,
  HostListener,
  EventEmitter,
  VERSION,
} from "@angular/core";
import { OverlayContainer } from "@angular/cdk/overlay";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Observable, Subject, Subscription, catchError, debounceTime, distinctUntilChanged, filter, map, of, switchMap, takeUntil } from "rxjs";
import { HTTPService } from "src/app/services/http.service";
import { Router, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { UserAuthentication } from "src/app/interfaces/user-authentication";
import { NavItem } from "src/app/interfaces/nav-item";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { ThemeService } from "src/app/services/theme.service";
import { NotificationsService } from "src/app/services/notifications.service";
import { NavService } from "src/app/services/nav.service";
import { MenuServices } from "src/app/services/menu-service.services";
import { TabService } from "src/app/services/tab.service";
import { PermissionServices } from "src/app/services/permission.services";
import { DynamicLoaderService } from "src/app/services/dynamic-loader.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { DashboardFocusService } from "src/app/services/dashboard-focus.service";
import { CustomThemeService } from "src/app/services/custom-theme.service";
import { NzThemeBridgeService } from "src/app/services/nz-theme-bridge.service";
import { LanguageServices } from "src/app/services/LanguageServices";
import { StringUtils } from "src/app/system-utils/utils/StringUtils";
import { UserFormConfigComponent } from "src/app/forms/usuarios/user-form-config/user-form-config.component";import { Notification } from "src/app/interfaces/notifications";



@Component({
    selector: "app-system-view-new",
    templateUrl: "./system-view-new.component.html",
    styleUrls: ["./system-view-new.component.scss"],
    providers: [
        // Provide a value to be used by Angular's dependency injection
        // machanism to pass 
        { provide: 'navItens', useValue: 'navItems' },
    ],
    standalone: false
},
)
export class SystemViewNewComponent  implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("sidenav") sidenav: any;
    tipo: String = "";
    version = VERSION;
    userName: string = "Admin";
    companyName: string = "Tem API";
    ua: UserAuthentication;
    isDarkTheme: Observable<Boolean> = new Observable<Boolean>() ;
    img;
    useAvatar = false;
    versionApp: string = environment.versionApp;
    firstLoad = true;
    navItems: NavItem[] = [];
    useTab:boolean = false;
    showRecorder:boolean = false;
    canViewRec:boolean = true;
    //tabs = [];
    selectedTab:any = null;
    activeLink = null;
    linksRoute:Observable<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]> = new Observable();
    currentTab:BehaviorSubject<any> = new BehaviorSubject<any>({});
    formLink:FormGroup;
    hasActiveRoute: boolean = false;
    /** layout VAULT: aplica .vault-theme (paleta petróleo/teal do temapi-theme) */
    isVault: boolean = false;
    /** layout Claro Moderno: aplica .modern-theme (paleta azulada do temapi-theme) */
    isModern: boolean = false;
    /** layout Quente: aplica .warm-theme (paleta areia/terracota do temapi-theme) */
    isWarm: boolean = false;
    /** layout Violeta: aplica .violet-theme (paleta lilás/ameixa do temapi-theme) */
    isViolet: boolean = false;
    /** layout Laranja: aplica .orange-theme (paleta pêssego/laranja do temapi-theme) */
    isOrange: boolean = false;
    /** layout Personalizado: aplica .custom-theme (paleta do usuário gerada em runtime) */
    isCustom: boolean = false;
    /** layout Brasil: aplica .brasil-theme (verde/amarelo/azul da bandeira) */
    isBrasil: boolean = false;
    /** layout NG-Zorro: aplica .zorro-theme (paleta padrão do Ant Design) */
    isZorro: boolean = false;

    /** layout Bootstrap: aplica .bootstrap-theme (paleta do Bootstrap 5.3) */
    isBootstrap: boolean = false;
    selectedTabIndex: number = -1; // 0 = Dashboard, 1 = Routes
    @ViewChild('inputResourceFinder') inputResourceFinder:ElementRef;
    subIndex: Subscription;
    loadingLinks: boolean = false;
    
  constructor(

    public navService: NavService,
    public UserAuthenticationServices: UserAuthenticationServices,
    private overlayContainer: OverlayContainer,
    private themeService: ThemeService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    private notificationsService: NotificationsService,
    private http: HTTPService,
    private MenuServices: MenuServices,
    public tabService: TabService,
    private formBuilder: FormBuilder,
    private router:Router,
    private ap:PermissionServices,
    private ls:LanguageServices,
    private dynamicLoader: DynamicLoaderService,
    private modal:NzModalService,
    private dfs:DashboardFocusService,
    private customThemeService:CustomThemeService,
    private nzThemeBridge:NzThemeBridgeService
  ) {
    this.useTab = this.UserAuthenticationServices.user.usetab == null ? false :
                    this.UserAuthenticationServices.user.usetab == 'S' ? true:false;

    
    this.formLink = formBuilder.group({
        linkName:''
    });

    this.linksRoute = this.formLink.get('linkName')!.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(1000),
      filter((linkName) => !!linkName),
      switchMap(linkName => this.getMenuByName(linkName))
    );
    
    this.ua = JSON.parse(localStorage.getItem("user"));
    this.companyName = this.ua.companyname;
    this.userName = this.ua.username;


  }

  ngOnDestroy(): void {

    if (this.subIndex != null) {
      this.subIndex.unsubscribe();
    }

    // ao trocar para a moldura antiga (light/dark) as classes de tema
    // desta moldura não podem ficar penduradas no overlay
    const overlayClasses = this.overlayContainer.getContainerElement().classList;
    overlayClasses.remove("vault-theme");
    overlayClasses.remove("modern-theme");
    overlayClasses.remove("warm-theme");
    overlayClasses.remove("violet-theme");
    overlayClasses.remove("orange-theme");
    overlayClasses.remove("custom-theme");
    overlayClasses.remove("brasil-theme");
    overlayClasses.remove("zorro-theme");
    overlayClasses.remove("bootstrap-theme");
  }

  async loadPermissions() {
    await Promise.all(this.MenuServices.promiseMenuArr); //espera terminar a recursão da montagem dos menus para casar as permissões. Verificar se depois temos que mover para outro lugar pelo delay.

    if (this.firstLoad) {
      this.navItems = JSON.parse(JSON.stringify(this.MenuServices.navItems));
      this.firstLoad = false;
    }

    this.disableAll(this.navItems);

    // a visibilidade do menu vem da MKTPMENUACESS, a mesma tabela gravada pela
    // tela de acessos e consultada pela busca Ctrl+K. ADMIN recebe null e enxerga tudo.
    let permitidos = await this.MenuServices.getMenuAcess();

    if (permitidos == null) {
      this.enableAll(this.navItems);
      return;
    }

    this.applyMenuAcess(this.navItems, permitidos);
  }

  async loadMenu() {
    return new Promise((resolve,reject)=>{
      this.MenuServices.getMenus().then(async (x) => {
        await this.loadPermissions();
        this.tabService.findRecursive(this.navItems);
        resolve(true)
      });
    });
    
    
  }

  

  disableAll(navItem: NavItem[]) {
    navItem.forEach((nav) => {
      if (nav.children != null && nav.children.length > 0) {
        this.disableAll(nav.children);
        nav.visible = false;
        nav.hidden = false;
        nav.expanded = false;
      } else {
        nav.visible = false;
        nav.expanded = false;
        nav.hidden = false;
      }
    });
  }

  /** libera a arvore inteira; usado apenas para o perfil ADMIN */
  enableAll(navItem: NavItem[]) {
    navItem.forEach((nav) => {
      nav.visible = true;
      nav.hidden = false;

      if (nav.children != null && nav.children.length > 0) {
        this.enableAll(nav.children);
      }
    });
  }

  /**
   * Marca visible a partir das liberacoes gravadas na MKTPMENUACESS.
   *
   * Item folha aparece quando o NUMENU dele esta liberado. Grupo aparece quando
   * tem ao menos um filho visivel: como o template nunca navega a partir do
   * grupo, um grupo sem filho liberado seria apenas uma pasta vazia na tela.
   *
   * Retorna se algum item deste nivel ficou visivel, para o nivel de cima decidir.
   */
  applyMenuAcess(navItem: NavItem[], permitidos: Set<string>): boolean {
    let algumVisivel = false;

    navItem.forEach((nav) => {
      if (nav.children != null && nav.children.length > 0) {
        nav.visible = this.applyMenuAcess(nav.children, permitidos);
      } else {
        nav.visible = permitidos.has(String(nav.nuMenu));
      }

      nav.hidden = false;

      if (nav.visible) {
        algumVisivel = true;
      }
    });

    return algumVisivel;
  }

  loadImage() {
    if (this.ua.useravatar != null) {
      let objectURL = "data:image/png;base64," + this.ua.useravatar;
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.useAvatar = true;
    }
  }

  async ngOnInit(): Promise<void> {

    this.subIndex = this.tabService.activeTabIndex.subscribe(index => {
        this.selectedTabIndex = index;
    });

    try{
      this.ls.setDefaultLanguage();
      // o dicionario ja foi carregado no bootstrap (bundle + cache, sem sessao);
      // agora que existe token, releitura do MKTPLANGUAGE
      this.ls.reloadFromServer();
      this.isDarkTheme = this.themeService.isDarkTheme;
      
      this.isDarkTheme.subscribe(dadata=>{
          localStorage.setItem('darkTheme',String(dadata));
      });

      this.canViewRec = this.ap.checkPermission('Mktpmedia').canInsert;
      this.loadMenu().then(d=>{
        this.navService.sidenavSmall =  localStorage.getItem('small-menu')==null? false :  StringUtils.stringToBoolean(localStorage.getItem('small-menu'));
        let language= localStorage.getItem('language')==null?'pt-BR': localStorage.getItem('language');
        setTimeout(()=>this.changeLanguage(language));
      });

      this.loadImage();
      this.loadTabs();
      this.dfs.setFocus(false);

      
        
  
      // Rastrear mudanças de rota para controlar aba
      this.router.events.pipe(
        filter((event: any) => event instanceof NavigationEnd),
        debounceTime(100)
      ).subscribe((event: NavigationEnd) => {
        const currentUrl = event.url;
        const isHome = currentUrl === '/' || currentUrl === '/home' || currentUrl === '';
        if (isHome) {
          this.hasActiveRoute = false;
        } else {
          // Procura a tab correspondente à URL
          const tabIdx = this.tabService.tabs.findIndex(tab => tab.url === currentUrl);
          if (tabIdx !== -1) {
            this.hasActiveRoute = true;
          } else {
            // Se não encontrar, mantém o índice atual
            this.hasActiveRoute = true;
          }
        }
      });

      // Inicializar o estado
      const currentUrl = this.router.url;
      const isHome = currentUrl === '/' || currentUrl === '/home' || currentUrl === '';
      if (isHome) {
        this.hasActiveRoute = false;
      } else {
        const tabIdx = this.tabService.tabs.findIndex(tab => tab.url === currentUrl);
        if (tabIdx !== -1) {
          this.hasActiveRoute = true;
        } else {
          this.hasActiveRoute = true;
        }
      }

    }catch(Exception ){
      this.UserAuthenticationServices.gotoLogin();
    }
    

  }
  loadTabs() {
    this.tabService.loadTabs();
  }

  
  ngAfterViewInit() {
    this.navService.appDrawer = this.sidenav;
    
    setTimeout(()=>{
      // sem layout salvo o selector carrega o chrome moderno — a paleta acompanha
      this.change(this.ua.layout != null ? this.ua.layout : "light_modern");
    },0)
  }

 

  toggleSider() {
    this.navService.sidenavSmall = !this.navService.sidenavSmall
    this.saveOption(this.navService.sidenavSmall);
  }

  
  close(tipo: String) {
    this.tipo = tipo;
    this.sidenav.close();
  }

  backToDashboard() {
    this.hasActiveRoute = false;
    this.dfs.setFocus(true);
  }

  backToRoute(){
    if ( this.tabService.tabs.length > 0){
        this.hasActiveRoute = true;
        this.dfs.setFocus(false);
        if (this.tabService.tabs.length > 0 && this.selectedTabIndex==-1){ 
        this.selectedTabIndex = 0;
        const tab = this.tabService.tabs[0];
        if (tab && tab.url) {
            this.router.navigate([tab.url], { skipLocationChange: true });
        }
        }
    }
  }

  
  logout() {
    this.tabService.tabs = [];
    this.UserAuthenticationServices.logout();
  }

  reload(data) {
    this.ua = JSON.parse(localStorage.getItem("user"));
    if (this.ua.layout != null) {
      this.change(this.ua.layout);
    }

    this.loadImage();
    this.cd.detectChanges();
  }

  openConf() {
     const modalRef = this.modal.create({
      nzTitle: this.ls.instant('systemView.userConfig'),
      nzContent: UserFormConfigComponent,
      nzWidth: '80vw',
      nzFooter: null,
      nzMaskClosable: false,
      nzCentered: true,
      nzBodyStyle: { display: 'flex', overflow: 'auto' , height:"80vh", width:"100%"},
      nzClosable: true,
      nzData: {
        user: this.ua
      }
    });

    // reaplica avatar/nome/paleta salvos no user-form-config (sem F5)
    modalRef.afterClose.subscribe(() => this.reload(null));
  }

  private setOverlayClass() {
    this.overlayContainer
      .getContainerElement()
      .classList.add("theme-alternate");
  }

  private removeOverlayClass() {
    this.overlayContainer
      .getContainerElement()
      .classList.remove("theme-alternate");
  }

  change(event: string) {
    // 'vault' = dark do temapi-theme (.theme-alternate) + paleta própria (.vault-theme)
    // 'light_modern' = paleta clara azulada (.modern-theme); sem classe = Claro neutro
    // 'warm' = paleta clara areia/terracota (.warm-theme)
    // 'violet' = paleta clara lilás/ameixa (.violet-theme)
    // 'orange' = paleta clara pêssego/laranja (.orange-theme)
    // 'brasil' = paleta clara verde/amarelo (.brasil-theme)
    // 'zorro' = paleta padrão do Ant Design (.zorro-theme)
    // 'bootstrap' = paleta do Bootstrap 5.3 (.bootstrap-theme)
    // 'custom' = paleta do usuário (.custom-theme gerada em runtime pelo CustomThemeService)
    this.isVault = event == "vault";
    this.isModern = event == "light_modern";
    this.isWarm = event == "warm";
    this.isViolet = event == "violet";
    this.isOrange = event == "orange";
    this.isCustom = event == "custom";
    this.isBrasil = event == "brasil";
    this.isZorro = event == "zorro";
    this.isBootstrap = event == "bootstrap";
    const overlayClasses = this.overlayContainer.getContainerElement().classList;
    overlayClasses.toggle("vault-theme", this.isVault);
    overlayClasses.toggle("modern-theme", this.isModern);
    overlayClasses.toggle("warm-theme", this.isWarm);
    overlayClasses.toggle("violet-theme", this.isViolet);
    overlayClasses.toggle("orange-theme", this.isOrange);
    overlayClasses.toggle("custom-theme", this.isCustom);
    overlayClasses.toggle("brasil-theme", this.isBrasil);
    overlayClasses.toggle("zorro-theme", this.isZorro);
    overlayClasses.toggle("bootstrap-theme", this.isBootstrap);

    if (this.isCustom) {
      // carrega/aplica a paleta salva; a base (claro/escuro) decide grids e sombras
      this.customThemeService.loadAndApply(this.UserAuthenticationServices.user.iduser).then(palette => {
          let isDark = palette.base == 'dark';
          this.themeService.setDarkTheme(isDark);
          if (isDark) {
            this.setOverlayClass();
          } else {
            this.removeOverlayClass();
          }
          this.cd.detectChanges();
      });
      return;
    }

    this.customThemeService.clear();

    // sincroniza as variáveis --ant-* dos componentes NG-Zorro com o tema
    this.nzThemeBridge.syncFixed(event);

    if (event == "dark" || event == "vault") {
      this.themeService.setDarkTheme(true);
      this.setOverlayClass();
    } else {
      this.removeOverlayClass();
      this.themeService.setDarkTheme(false);
    }
  }
  
  closeTab(index:{ index: number }) {
    
    try{
        this.tabService.deleteTab(index.index);
        if( index.index -1  < 0){
        
        if ( this.tabService.tabs.length >0){
            this.selectedTabIndex = 0;
            this.router.navigate([this.tabService.tabs[this.selectedTabIndex].url], { skipLocationChange: true });
        }else{
            this.selectedTabIndex = -1;
            this.router.navigate([""], { skipLocationChange: true });
        }
        
    }else{
        this.selectedTabIndex = index.index -1;
        this.router.navigate([this.tabService.tabs[this.selectedTabIndex].url], { skipLocationChange: true });
        }    
    }catch(Exception){
        console.error('Error occurred while closing tab:', Exception);
        this.router.navigate([""], { skipLocationChange: true });
    }
    
  }

  changeLanguage(language: string) {
    
    this.ls.changeLanguage(language).then((d) => {
      this.cd.detectChanges();
    });
    
  }
  
  saveOption(small:boolean){
      localStorage.setItem("small-menu",small.toString());
  }


  onTabChange(index: number) {
     const tab = this.tabService.tabs[index];
      if (!tab || !tab.url) {
        console.warn('Tab sem URL para índice', index, tab);
        return;
      }

      // se as rotas são filhas de SystemViewComponent:
      this.router.navigate([tab.url], { skipLocationChange: true }).then(() => {
        this.hasActiveRoute = true;
        this.cd.detectChanges();
      });
        
    
  }

  // navigate(tab){
  //   this.router.navigate([tab.url], { skipLocationChange: true });
  // }

  // displayFn(route): string {
  //   return route && route.DESCRIPTION ? route.DESCRIPTION : '';
  // }

  trackByRoute(index: number, route: any): any {
     return route?.IDMENU || index;
  }

  getMenuByName(name):Observable<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]>{
    this.loadingLinks = true;
    
      let ob = {
          "entityName":"Mktpmenu",
          "sql":`SELECT DISTINCT MKTPMENU.* FROM MKTPMENU INNER JOIN MKTPMENUACESS ON MKTPMENU.NUMENU = MKTPMENUACESS.NUMENU
            WHERE ISNULL(MKTPMENU.TYPE,'')!='R' 
            AND (SOUNDEX(MKTPMENU.DESCRIPTION) = SOUNDEX('${name}') OR MKTPMENU.DESCRIPTION LIKE '%${name}%')
            AND ${this.UserAuthenticationServices.user.profile=='ADMIN' ? '0=0': "MKTPMENUACESS.IDUSER= "+this.UserAuthenticationServices.user.iduser}`
      };

      return this.http.postGeneric<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]>(ob,'JsonBrokerServices/findnative',false,true,false,false).pipe(
          map(list=>{
            let info =  list['SQL'];
            let array:{IDMENU:string, DESCRIPTION:string,svgIconName:string, iconName:string}[]  = [];
            for ( var l of info ){
                let properties = JSON.parse(l.PROPERTIES);
                let svgIconName = properties['svgIconName'];
                let iconName = properties['iconName'];
                
                array.push( {IDMENU:l.IDMENU, DESCRIPTION: l.DESCRIPTION, svgIconName: svgIconName, iconName: iconName});
            }
            this.loadingLinks = false;
            return array;
          }),
          catchError(err=>{
            console.error('Error fetching menu by name:', err);
            this.loadingLinks = false;
            return of([]);
          })
      )
  }

  onSelectItem($event: any){
    // ng-zorro emite o evento com a opção
    const value = $event?.nzValue || $event;

    let navItem:NavItem = {
        displayName:'dummy',
        expanded:false,
        hidden:false,
        id:'0',
        nuMenu:value,
        route:value,
        visible:false,
        level:0
    }

    this.navService.selectItem(navItem, this.useTab, this.router, this.tabService, value, this.UserAuthenticationServices.user.iduser);
    // Limpar o campo após seleção
    this.formLink.get('linkName')?.reset();
  }

  @HostListener('window:keydown.control.k', ['$event'])
  public onKeyUp(event: KeyboardEvent): void {
    event.preventDefault();
    this.inputResourceFinder.nativeElement.focus();
  }

  trackByUrl(index: number, tab: any) {
    return tab.url;
  }

} 